import React from 'react'

// Form-level error (e.g. a failed sign-in/sign-up attempt) - shown once near the top of the
// form, above the fields. Same red-tinted-surface treatment as FieldError, sized for a
// sentence or two instead of a single short message.
function FormErrorBanner({ children }) {
  if (!children) return null
  return (
    <div className="flex items-start gap-2 mb-4 px-3.5 py-3 bg-red-50 border border-red-200 rounded-sm">
      <svg width="15" height="15" viewBox="0 0 20 20" fill="none" className="flex-none mt-[2px]">
        <circle cx="10" cy="10" r="8.25" stroke="#b91c1c" strokeWidth="1.4" />
        <path d="M10 6.2v4.6" stroke="#b91c1c" strokeWidth="1.6" strokeLinecap="round" />
        <circle cx="10" cy="13.7" r="0.9" fill="#b91c1c" />
      </svg>
      <p className="m-0 font-plexsans text-[13px] leading-[1.5] text-red-700 text-left">{children}</p>
    </div>
  )
}

export default FormErrorBanner
